module.exports = __webpack_public_path__ + "static/media/luggage-cart.3cf3cd55.svg";